import {ChangeDetectorRef, Component, Input} from '@angular/core';
import {ChartConfiguration, ChartData, ChartDataset, ChartEvent, ChartType} from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
  selector: 'app-chart-display',
  template: `
    <div class="grid-container" style="padding: 50px">
      <div class="text-center">
        <label ><strong class="text-center">{{ chartTitle }}</strong></label>
      </div>
      <div class="row row-cols-1 row-cols-md-3 g-4">
        <div class="typecenter">
          <canvas baseChart
                  [height]="600"
                  [labels]="chartLabels"
                  [datasets]="chartDatasets"
                  [options]="chartOptions"
                  [legend]="true"
                  [type]="'pie'">
          </canvas>&nbsp;

        </div>
      </div>
    </div>
  `,
  styles: [`
    /* Add any necessary styles here */
  `]
})
export class ChartDisplayComponent {
  constructor(
      private changeDetector: ChangeDetectorRef
  ) {
  }
  @Input() chartLabels: string[] = [];
  @Input() chartDatasets: ChartDataset<"pie", number[]>[] | undefined = [];
  @Input() chartOptions: ChartConfiguration<'pie'>['options'] = {
    plugins:{
      legend: {display:true}
    },

  };
  @Input() chartTitle: string = '';
}
